"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntityLike = exports.Entity = exports.EntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.EntityClassName = 'Entity';
class Entity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.EntityClassName)
            throw new Error(`Tried to create a ${exports.EntityClassName} from a ${ob.type} object!`);
        super(exports.EntityClassName, { ...ob });
        this.type = ob.type ?? exports.EntityClassName;
        this.name = ob.name;
        this.category = ob.category ?? ob.Category ?? '';
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
        this.updated_at = ob.updated_at ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            category: {
                type: 'String',
                editable: true,
                label: 'Category',
                name: 'category',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Category cannot contain invalid characters' },
            },
        };
    }
    /**
     * Returns a zombie suitable to find a scoreconfig pseudoattribute for the entity
     */
    getScoreConfigZombie() {
        return {
            pk: this.pk,
            sk: `ScoreConfig:${this.id}_scoreConfig`,
            id: `${this.id}_scoreConfig`,
            type: 'ScoreConfig',
        };
    }
}
exports.Entity = Entity;
const isEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.EntityClassName;
};
exports.isEntityLike = isEntityLike;
